import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "top-0 lg:top-16 xl:top-0 inset-x-0" }
const _hoisted_2 = {
  key: 0,
  class: "mt-3 text-center font-display px-4 text-sm text-white"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "px-2 text-amff-gray" }, "·", -1)
const _hoisted_4 = {
  key: 2,
  class: "block mx-auto max-w-full",
  viewBox: "0 -20 1440 470",
  width: "1440px"
}
const _hoisted_5 = {
  y: "425",
  x: "720",
  fill: "currentColor",
  stroke: "transparent",
  class: "text-8xl text-white font-display",
  "text-anchor": "middle"
}
const _hoisted_6 = { class: "\n        mt-4\n        text-white text-center text-md\n        md:text-xl\n        lg:text-4xl\n        font-display\n        max-w-sm\n        md:max-w-lg\n        lg:max-w-5xl\n        mx-auto\n      " }
const _hoisted_7 = { class: "\n        mt-4\n        text-white text-center text-md\n        md:text-xl\n        lg:text-4xl\n        font-display\n        max-w-sm\n        md:max-w-lg\n        lg:max-w-5xl\n        mx-auto\n      " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t("header.mallorca_edition")) + " ", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("header.online_edition")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["font-display text-center text-3xl md:text-6xl my-5", {
        'text-amff-teal': !_ctx.isOnline,
        'text-filmin-green': _ctx.isOnline,
      }]
        }, _toDisplayString(_ctx.texts[0]) + _toDisplayString(_ctx.texts[1]) + _toDisplayString(_ctx.texts[2]), 3))
      : (_openBlock(), _createBlock("svg", _hoisted_4, [
          _createVNode("text", {
            y: "352",
            x: "720",
            fill: "transparent",
            stroke: "currentColor",
            "stroke-width": "2",
            class: ["text-8xl font-display", 
          _ctx.color === 'filmin-green' ? 'text-filmin-green' : 'text-amff-teal'
        ],
            "text-anchor": "middle"
          }, _toDisplayString(_ctx.texts[0]) + _toDisplayString(_ctx.texts[1]) + _toDisplayString(_ctx.texts[2]), 3),
          _createVNode("text", _hoisted_5, _toDisplayString(_ctx.texts[0]) + _toDisplayString(_ctx.texts[1]) + _toDisplayString(_ctx.texts[2]), 1)
        ])),
    _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("home.header_description")), 1),
    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("home.header_description2")), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}